import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_QUOTE_ID_LOADING = 'GET_QUOTE_ID_LOADING';
export const GET_QUOTE_ID_SUCCESS = 'GET_QUOTE_ID_SUCCESS';
export const GET_QUOTE_ID_REJECT = 'GET_QUOTE_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getQuoteIdLoading = () => ({ type: GET_QUOTE_ID_LOADING });
export const getQuoteIdSuccess = (payload) => ({ type: GET_QUOTE_ID_SUCCESS, payload });
export const getQuoteIdReject = (payload) => ({ type: GET_QUOTE_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getQuoteIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Quote/${id}`, options);
};